"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.updateTransaction = void 0;
var bignumber_js_1 = require("bignumber.js");
var createTransaction = function (_) {
    return {
        family: "solana",
        amount: new bignumber_js_1.BigNumber(0),
        useAllAmount: false,
        recipient: "",
        model: {
            kind: "transfer",
            uiState: {
                memo: undefined
            }
        }
    };
};
var updateTransaction = function (t, patch) {
    return __assign(__assign({}, t), patch);
};
exports.updateTransaction = updateTransaction;
exports["default"] = createTransaction;
//# sourceMappingURL=js-createTransaction.js.map